<template>
  <p class="text-muted field-help">
    {{ text }}
  </p>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

.field-help {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  line-height: 1.5;
  align-items: flex-start;

  @include breakpoints.screen-mobile-only {
    font-size: 14px;
  }

  &::before {
    content: url('../images/info.svg');
    background: #cccccc;

    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    flex: 0 0 28px;

    border-radius: 16px;
    margin-right: 16px;
    padding: 8px 9px;
  }
}
</style>
